/**
 * Summary Header Component for LeadsalesAI Bubble
 * Includes delete functionality specific to AI events
 */

import { TrashIcon } from '@heroicons/react/24/outline';
import { Button, Loading } from 'react-daisyui';
import { formatTime } from '../../../../../../../ConversationSummary/ConversationSummary.functions';

export type TSummaryHeaderAIProps = {
  generatedAt: string;
  onDelete: () => void;
  loading: boolean;
};

export default function SummaryHeader(props: TSummaryHeaderAIProps) {
  return (
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-8 h-8 bg-blue-600 rounded-full">
          <span className="text-white text-sm">🤖</span>
        </div>
        <div>
          <h4 className="font-semibold text-gray-900 text-sm">
            Resumen de Conversación
          </h4>
          <p className="text-xs text-gray-500">
            Generado a las {formatTime(props.generatedAt)}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="bg-amber-100 text-amber-800 px-2 py-1 rounded-full text-xs font-medium">
          Solo visible para agentes
        </div>
        <Button size="xs" color="ghost" shape="circle" onClick={props.onDelete}>
          {props.loading ? (
            <Loading className="w-4 h-4" />
          ) : (
            <TrashIcon className="w-4 h-4" />
          )}
        </Button>
      </div>
    </div>
  );
}
